import { createFileRoute } from '@tanstack/react-router';
import Sso from '../../components/Sso';

function SsoRoute() {
  return <Sso />;
}

export const Route = createFileRoute('/connect/web')({
  component: SsoRoute,
});
